import { ReactNode } from "react";
import { UserProvider } from "./UserContext";
import { ThemeProvider } from "./ThemeContext";
import { NotificationsProvider } from "./NotificationsProvider";

export const AppProviders = ({ children }: { children: ReactNode }) => {
  return (
    <UserProvider>
      <ThemeProvider>
        <NotificationsProvider>{children}</NotificationsProvider>
      </ThemeProvider>
    </UserProvider>
  );
};
